import { AuthenticationService } from './../../services/authentication.service';
import { shareReplay } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { PerfilService } from 'src/app/services/perfil.service';
import { GeneralService } from 'src/app/services/general.service';
/* amnet.cl\adexus4 -- VPN */

import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}
@Injectable({
    providedIn: 'root'
})
export class ServiceComponents {
    private beneficiosRequest: any = {};
    private dataClienteSource = new BehaviorSubject<any>([]);
    public dataCliente$ = this.dataClienteSource.asObservable();
    private links:any;

    constructor(private auth: AuthenticationService,
        private httpClient: HttpClient,
        private generalService: GeneralService,
        private perfilService: PerfilService) { }

    /**
  * Función Que realiza la recuperacion de clave 
  * @param pRut
  * @param pPass
  * @param pIdPregunta
  * @param pRespuesta
  */
    recoveryPassword(pRut: any, pPass: any, pIdPregunta: any, pRespuesta: any) {
        return this.httpClient.put(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/SetResetPassCliente?pRut=` + pRut + `&pPass=` + pPass + `&pIdPregunta=` + pIdPregunta + `&pRespuesta=` + pRespuesta, httpOptions);
    }
    /**
      * Función Que realiza el cambio de clave 
      * @param pRut
      * @param pPass
      * @param pNewPass
      * @param pIdPregunta
      * @param pRespuesta
      */
    changePassword(pRut: any, pPass: any, pNewPass: any, pIdPregunta: any, pRespuesta: any) {
        return this.httpClient.put(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/SetUpdPassCliente?pRut=` + pRut + `&pPass=` + pPass + `&pNewPass=` + pNewPass + `&pIdPregunta=` + pIdPregunta + `&pRespuesta=` + pRespuesta, httpOptions);
    }

    /**
  * Función Que Retorna Todo Los casinos Del Sistema Enjoy 
  */
    getListadoCasinos() {
        return new Observable(resolve => {
            this.generalService.getEnvironmentSetted().subscribe(environmentSetted => {
                if (environmentSetted) {

                    console.log(`${environment.api_baseurl_ecc_socios}/api/unidades`);
                    this.httpClient.get(`${environment.api_baseurl_ecc_socios}/api/unidades`).subscribe(response => {
                        resolve.next(response);
                        resolve.complete();
                    });
                }
            });
        });
    }
    /**
   * Función Para enrolar el cliente (Registro)
   *  @param token 
   *  @param rut 
   *  @param nombre 
   *  @param apellido 
   *  @param email 
   *  @param telefono 
   *  @param pais 
   *  @param fechaNacimiento 
   */
    setEnrolarCliente(params: any) {

        return this.httpClient.post(`${environment.api_baseurl_ecc_socios}/api/Clientes/SetCliente`, params, httpOptions);
        // return this.httpClient.post(`${environment.path}/ecc.socios/api/Clientes/SetCliente`, params, httpOptions);
    }
    /**
     * Función Que Retorna Todo Los Paises Del Sistema Enjoy
     */
    getPaises() {
        return new Observable(resolve => {
            this.generalService.getEnvironmentSetted().subscribe(environmentSetted => {
                if (environmentSetted) {
                    const url = `${environment.path}/ecc.transversal/api/Pais`;
                    this.httpClient.get(url).subscribe(response => {
                        resolve.next(response);
                        resolve.complete();
                    });
                }
            });
        });
    }

    ingreso(pRut: any, pPass: any) {
        console.log(`${environment.path}/api/Clientes`);
        return this.httpClient.get(`${environment.path}/ecc.socios/api/Socios?sRut=` + pRut + `&sPassw=` + pPass);
    }
    /**
    * Función que almacena la información del cliente
    * @param value
    */
    setDataTotem(value) {
        this.dataClienteSource.next(value);
    }
    /**
   * Obtiene un cliente según idCliente y unidad entregados por parámetros
   * @param pCliente
   * @param pIdUnidad
   * @param pIdAplicacion
   */
    getClientes(pIdCliente: any = 0, pIdUnidad: any = 0, pIdAplicacion: any = 0) {

        return new Observable(resolve => {
            let url = `${environment.api_baseurl_ecc_socios}/api/Clientes/`;
            url += 'idUnidad=' + pIdUnidad;
            url += '&idCliente=' + pIdCliente;
            url += '&idAplicacion=' + pIdAplicacion;
            this.httpClient.get(url).subscribe(
                response => {
                    if (response['codigo'] === 1) {
                        // se agrega para que notifique la data del usuario que ha iniciado sesión
                        this.setDataTotem(response['data']);
                        this.perfilService.setDataCliente(response['data']);
                    } else {
                        console.log('limpiando data cliente');
                        this.setDataTotem(null);
                        this.perfilService.setDataCliente(null);
                        if (this.auth.isLoggedIn) {
                            // this.auth.logout();
                        }
                    }
                    resolve.next(response);
                    resolve.complete();

                },
                error => {
                    // this.auth.logout();
                });
        });
    }

    /**
     * Función Que responde la pregunta del usuario
     * @param rut
     */
    getPreguntaUsuario(rut: any) {
        return this.httpClient.get(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/GetPreguntaCliente?pRut=` + rut);
    }
    /**
     * Función Que Valida las respuesta de las preguntas de seguridad 
     * @param rut
     * @param idPRegunta
     * @param respuesta
     */
    validaRespuesta(rut: any, idPRegunta: any, respuesta: any) {
        return this.httpClient.get(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/GetValidaRespuestaCliente?pRut=` + rut + `&pIdPregunta=` + idPRegunta + `&pRespuesta=` + respuesta);
    }
    /**
    * Función Que retorna las preguntas de seguridad 
    */
    GetPreguntasSeguridad() {
        return this.httpClient.get(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/GetPreguntasSeguridad`);
    }

    getBeneficios(pIdCliente: any = 0, pIdUnidad: any = 0, pIdAplicacion: any = 0) {
        const identifier = `${pIdCliente}-${pIdUnidad}-${pIdAplicacion}`;
        if (isNullOrUndefined(this.beneficiosRequest[identifier])) {
            let url = `${environment.api_baseurl_ecc_socios}/api/Clientes/`;
            url += 'idUnidad=' + pIdUnidad;
            url += '&idCliente=' + pIdCliente;
            url += '&idAplicacion=' + pIdAplicacion;

            this.beneficiosRequest[identifier] = this.httpClient.get(url).pipe(shareReplay(1));
        }
        return this.beneficiosRequest[identifier];
    }

    getLinks() {
        // tslint:disable-next-line: max-line-length
        if(this.links==null)
            this.links = this.httpClient.get(`${environment.path}${environment.service.links.endpoint}GetLinks`).toPromise();
        return this.links;
    }

}
